import groq from 'groq';

// Decorative images (backgrounds) are presentational: no alt is queried.
export const ASSET_DECORATIVE = groq`
  _key,
  _type,
  asset -> {
    _id
  }
`;
